module.exports = __webpack_public_path__ + "static/media/influenced.763f5617.svg";